export interface NotFoundResponse {
    notFound: true
}

const notFoundResponse = (): NotFoundResponse => ({
    notFound: true
})

export default notFoundResponse
